import { userPilotAdapter } from "./user-pilot/UserPilotAdapter";

export type TrackedUser = {
  id: string;
  name: string;
};

export type TrackedCompany = {
  id: string;
  name: string;
};

export type TrackingEvents =
  | "button_click"
  | "edit_job_post_opened"
  | "edit_job_post_reopen"
  | "edit_job_post_save_and_publish"
  | "edit_job_post_saved";

export interface TrackingAdapter {
  initialize: (token: string) => void;
  onLogin: (user: TrackedUser, company: TrackedCompany) => void;
  onPageChange: (url: string) => void;
  onEvent: (type: TrackingEvents, properties: Record<string, string>) => void;
  clearWebStorage: () => void;
}

export function getTracking(vendor: "userpilot"): TrackingAdapter {
  switch (vendor) {
    case "userpilot":
      return userPilotAdapter;
    default:
      throw "Unknown Tracking Adapter";
  }
}
